import { useAppState } from "../../context-hooks/useAppState";
import { useCoordinates } from "./useCoordinates";

/**
 * a hook that grabs zipcode from state and then queries the mapbox endpoint to get coordinates
 * @returns coordinates as [-76.567157, 39.286619], plus isResolving, which is
 * true while an enabled geocode has not yet succeeded or failed
 */
export const useZipcodeCoordinates = ({
  enabled = true,
  zipcodeOverride,
}: {
  enabled?: boolean;
  zipcodeOverride?: string;
} = {}) => {
  // * Context
  const { zipcode } = useAppState();
  const searchZipcode = zipcodeOverride ?? zipcode;
  return useCoordinates({
    address: enabled ? searchZipcode : undefined,
    enabled,
  });
};
